import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../config/rbac/actions.ts";
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";


export const OrdersLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListOrders}>
                    <IndexPage/></RestrictedRouteElement>}
            />
            <Route
                path='add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateOrder}>
                    <AddPage/></RestrictedRouteElement>}
            />
            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetOrder}>
                    <EditPage/></RestrictedRouteElement>}
            >
            </Route>


        </Routes>
    );
};
